module.exports = __webpack_public_path__ + "static/media/4.question.f92847cd.mp4";